import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Params} from "@angular/router";
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {Company} from "../type/company";
import {User} from "../type/user";
import {IMyOptions} from "mydatepicker";
import {CompanyStatus} from "../type/company-status";
import {Category} from "../type/category";

@Component({
    selector: 'app-company-edit',
    templateUrl: './company-edit.component.html',
})
export class CompanyEditComponent implements OnInit {
    node = 'company';
    usersNode = 'user';
    companyStatusNode = 'company-status';
    companyCategoryNode = 'company-category';

    users: [User] = [User];
    selectedCompany: Company = [Company];
    companyCategories: [Category] = [Category];
    companyStatuses: [CompanyStatus] = [CompanyStatus];

    myDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
    };

    constructor(
        private dataService: DataService,
        private apiService: ApiService,
        private route: ActivatedRoute,
        private location: Location
    ) {
    }

    ngOnInit() {
        this.dataService.refresh();
        this.route.params
            .subscribe(
                (params:Params) => {
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            this.selectedCompany = response.json().data[0];
                        });
                }
            );
        this.getUsers();
        this.getCompanyStatuses();
        this.getCompanyCategories();
    }

    getUsers() {
        this.apiService.getAll(this.usersNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.users = [User];
                } else {
                    this.users = response.json().data;
                }
            })
    }

    getCompanyStatuses() {
        this.apiService.getAll(this.companyStatusNode)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.companyStatuses = [CompanyStatus];
                    } else {
                        this.companyStatuses = response.json().data;
                    }
                },
                (error) => {this.companyCategories = [{}];}
            );
    }

    getCompanyCategories() {
        this.apiService.getCatAll(this.companyCategoryNode)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.companyCategories = [Category];
                    } else {
                        this.companyCategories = response.json().data;
                    }
                },
                (error) => {
                    this.companyCategories = [{}];
                }
            );
    }

    onFormSubmit(formData) {
        var data = {
            company_name: formData.value.company_name,
            contact_person: formData.value.contact_person,
            designation: formData.value.designation,
            landline: formData.value.landline,
            mobile: formData.value.mobile,
            email: formData.value.email,
            website: formData.value.website,
            location: formData.value.location,
            description: formData.value.description,
            additional_info: formData.value.additional_info,
            company_status_id: formData.value.company_status_id,
            company_category: formData.value.company_category,
            company_quota: formData.value.company_quota,
            priority_level: formData.value.priority_level,
            last_contacted_by: formData.value.last_contacted_by,
            last_contacted_at: formData.value.last_contacted_at.formatted,
            approved_status: formData.value.approved_status
        };
        this.apiService.update(this.node, [this.selectedCompany.company_id], data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: Company updated successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/companies/company-edit.component.ts